export function smoothScroll(elementId: string, offset = 0) {
  if (typeof document === 'undefined') {
    return;
  }

  const scrollTop = document.documentElement.scrollTop;
  const scrollTo = document.getElementById(elementId)!;
  if (scrollTo) {
    const top = scrollTop + scrollTo.getBoundingClientRect().top + offset;

    window.scroll({
      top,
      behavior: 'smooth',
    });
  }
}
